import React from 'react';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

import LogoImg from '../assets/logo.svg';

const Wrapper = styled.div`
  width: calc(100% - 140px);
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  align-items: center;
  padding: 45px 70px;

  @media (orientation: portrait) and (max-width: 767px) {
    padding: 15px 0;
    justify-content: center;
  }
`;

const CustomLink = styled.a`
  color: ${({ theme }) => theme.colors.basic100};
  font-size: 17px;
  font-weight: 600;
  margin: 0;
  border: none;
  outline: none;
  background: none;
  cursor: pointer;
  text-decoration: none;

  @media (orientation: portrait) and (max-width: 767px) {
    display: none;
  }
`;

const InnerLink = styled.span`
  color: ${({ theme }) => theme.colors.basic100};
  font-size: 17px;
  font-weight: 600;
  margin: 0;
  border: none;
  outline: none;
  background: none;
  cursor: pointer;
  text-decoration: none;

  @media (orientation: portrait) and (max-width: 767px) {
    display: none;
  }
`;

const Logo = styled.img`
  width: 60%;
  max-width: 220px;
  height: auto;
  margin-bottom: -30px;
  margin-top: -10px;
  cursor: pointer;
`;

const TopBar = () => {
  const navigate = useNavigate();

  const onClickLogo = () => navigate('/');

  return (
    <Wrapper>
      {/* <Link to="/nosotros" style={{ textDecoration: 'none' }}><InnerLink>Nosotros</InnerLink></Link>
      <Link to="/faq" style={{ textDecoration: 'none' }}><InnerLink>FAQ</InnerLink></Link> */}
      <Logo src={LogoImg} alt="Prestix" onClick={onClickLogo} />
      {/* <CustomLink href="#" target="_blank" rel="noopener noreferrer">Blog</CustomLink>
      <Link to="/terminos" style={{ textDecoration: 'none' }}><InnerLink>Términos</InnerLink></Link> */}
    </Wrapper>
  );
};

export default TopBar;